import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, inject } from 'intact-vue-next';
import template from './calendar.vdt';
import { useDays } from './useDays';
import { useState } from '../../hooks/useState';
import { DATEPICKER } from './constants';
import { useShowDate } from './useShowDate';
import { bind } from '../utils';
import { useYears } from './useYears';
import { useMonths } from './useMonths';
import { useStatus } from './useStatus';
import { useConfigContext } from '../config';
var defaults = function defaults() {
  return {
    type: 'date'
  };
};
export var DatepickerCalendar = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DatepickerCalendar, _Component);
  function DatepickerCalendar() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.type = useType(_assertThisInitialized(_this));
    _this.datepicker = inject(DATEPICKER);
    _this.showDate = useShowDate(_this.datepicker.panel);
    _this.status = useStatus(_this.datepicker.focusDate.focusDate);
    _this.days = useDays(_this.showDate.date, _this.status, _this.datepicker.focusDate.focusDate);
    _this.years = useYears(_this.showDate.date, _this.status, _this.datepicker.focusDate.focusDate);
    _this.months = useMonths(_this.showDate.date, _this.status, _this.datepicker.focusDate.focusDate);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = DatepickerCalendar.prototype;
  _proto.triggerChange = function triggerChange(value) {
    this.trigger('change', value, this.get('flag'));
  };
  return DatepickerCalendar;
}(Component);
DatepickerCalendar.template = template;
DatepickerCalendar.defaults = defaults;
__decorate([bind], DatepickerCalendar.prototype, "triggerChange", null);
function useType(instance) {
  var type = useState('date');
  instance.on('$receive:type', function (v) {
    type.set(v);
  });
  return type;
}